import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import RemoveLoadingScreen from '@/pages/RemoveLoadingScreen';
import ScrollToTop from '@/components/ScrollToTop';
import { Link } from 'react-router-dom';
import logo from '@communityshare/ui-shared/images/logo.png';
import { Helmet } from 'react-helmet-async';
import Bubbles from '@/pages/evaluation-project-educator/Bubbles';

export default function Layout(props) {
  const {
    project,
    page,
    onPrevious,
    onNext,
    onSkip,
    children
  } = props;

  return (
    <div className="flex h-screen overflow-hidden relative">
      {project && (
        <Helmet>
          <title>{`Project #${project.id}: ${page}`}</title>
        </Helmet>
      )}
      <RemoveLoadingScreen/>
      <Link className="cursor-pointer absolute top-5 left-6" to="/my-projects">
        <img className="h-16" src={logo} alt="logo" />
      </Link>
      <Bubbles />
      <div className="w-full relative">
        <ScrollToTop />
        {_.isFunction(children) ?
          children({
            onPrevious,
            onNext,
            onSkip
          }) :
          children
        }
      </div>
    </div>
  );
};

Layout.propTypes = {
  project: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  }),
  page: PropTypes.string,
  onPrevious: PropTypes.func,
  onNext: PropTypes.func,
  onSkip: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func])
};
